export default __webpack_public_path__ + "static/media/b_vision_mision.d7e3c536.jpg";